// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7569e4d5","703":"a57e4fab","787":"f8519bd2"}[chunkId] + ".chunk.js";
};